import script from "./FAQsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQsPage.vue?vue&type=script&setup=true&lang=js"

import "./FAQsPage.vue?vue&type=style&index=0&id=2e139f68&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e139f68"]])

export default __exports__